import { ISubscription } from "../../Types/WaterMeterTypes"
import { toCurrency } from "../../common/utilities/parser"
import { Table } from "react-bootstrap"

type SubscriptionProps = {
    subscriptions: ISubscription[],
}

const Subscription = (props: SubscriptionProps) => {


    return (
        <Table striped hover size="sm" responsive borderless>
            <thead className="tableHeader">
                <tr>
                    <th>Navn</th>
                    <th>Antall</th>
                    <th>Månedspris (ink. mva)</th>
                </tr>
            </thead>
            <tbody>
                {props.subscriptions.map(subscription => {
                    return (
                    <tr>
                        <td>{subscription.product.productName}</td>
                        <td>{subscription.quantity}</td>
                        <td>{toCurrency(subscription.totPriceGross, 2)}</td>
                    </tr>
                )})
            }
            </tbody>
        </Table>
    )
}

export default Subscription